import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Box,
  Button, Dialog, DialogTitle, DialogContent, DialogActions, Collapse, Grid, TextField, Switch, Divider, IconButton,
  FormControlLabel, Radio, RadioGroup, InputAdornment, Checkbox, FormControl, MenuItem, Select, Stack
} from "@mui/material";
import MessageIcon from '@mui/icons-material/Message';
import CallIcon from '@mui/icons-material/Call';
import BlockIcon from '@mui/icons-material/Block';
import PlayArrow from '@mui/icons-material/PlayArrow';
import RiderComm from '@mui/icons-material/MarkUnreadChatAlt';
import Call from '@mui/icons-material/Call';
import { useSelector } from "react-redux";
import { ExpandLess, ExpandMore, CheckCircle } from "@mui/icons-material";
import APICom from "../../utils/helpers/APICom";
import UberTripEventDetailedInfo from "./UberTripEventDetailedInfo";
import UberTripDetailedInfo from "./UberTripDetailedInfo";
import UberGuestRider from "./UberGuestRider";
import moment from "moment";

const UberExternalDispatch = (props) => {
  //Sandbox Section
  const [showPanel, setShowPanel] = useState(true); 
  const [enabledSandBox, setEnabledSandBox] = useState(false);
  const [sandboxEnabled, setSandboxEnabled] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [runId, setRunId] = useState("");
  const toggleSandbox = () => setSandboxEnabled((prev) => !prev);
  const toggleCollapse = () => setCollapsed((prev) => !prev);

  const [runResponse, setRunResponse] = useState({
    run_id: "",
    driver_ids: ""
  })
  //Sandbox Section

  const statusColors = {
    processing:         { bg: "#FFF3CD", color: "#856404" },  // yellow
    arriving:           { bg: "#D1ECF1", color: "#0C5460" },  // cyan
    in_progress:        { bg: "#CCE5FF", color: "#004085" },  // blue
    completed:          { bg: "#D4EDDA", color: "#155724" },  // green
    rider_canceled:     { bg: "#F8D7DA", color: "#721C24" },  // red
    driver_canceled:    { bg: "#F8D7DA", color: "#721C24" },  // red
    driver_redispatched:{ bg: "#E2E3E5", color: "#383D41" },  // gray
    no_drivers_available:{ bg: "#F5C6CB", color: "#721C24" }, // dark red
    accepted:           { bg: "#D1FFD6", color: "#155724" },  // light green
    scheduled:           { bg: "#CCE5FF", color: "#004085" },  // light blue
  };

  const [fetcTripEstimates, setFetcTripEstimates] = useState(true);
  const [affiliateID, setAffiliateID] = useState(-1);
  const [callBackInfo, setCallBackInfo] = useState("");
  const { loginData, GlobalASCSData, isLoading } = useSelector((store) => store.combinedata);
  const [callRider, setCallRider] = useState(true);
  const [driverNote, setDriverNote] = useState("");
  const [showTripConfigurations, setShowTripConfigurations] = useState(true);
  const [showEstablishCallSection, setShowEstablishCallSection] = useState(false);
  const [selectedCall, setSelectedCall] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showDriverMessageSection, setShowDriverMessageSection] = useState(false);
  const [driverMessage, setDriverMessage] = useState("");
  const [isTripAlreadyCreated, setIsTripAlreadyCreated] = useState(false);
  const [activeTripType, setActiveTripType] = useState("");
  const tripTypes = ["On Demand", "Scheduled"];//, "Flexible", "Reserve"];
  const [dialogHeader, setDialogHeader] = useState("Validation");
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedRefID, setSelectedRefID] = useState(-1);
  const [originalAffiliateId, setOriginalAffiliateID] = useState(-1);
  const [tripPickupDatetime, setTripPickupDatetime] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showTripCreatedDialogContent, setShowTripCreatedDialogContent] = useState(false);
  const [createdTripResponse, setCreatedTripResponse] = useState({
    eta: null,
    guest: {
      guest_id: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      has_coordinator_consented: false,
      locale: "",
      unregistered_user_uuid: "",
      isSandBoxEnabled: false,
      run_id: null,
      org_id: null,
      uberErrorResponse: null,
      httpStatusCode: 0,
      errorMessage: null,
      warningMessage: null,
      infoMessage: null
    },
    product_id: "",
    request_id: "",
    status: "",
    surge_multiplier: 1,
    isSandBoxEnabled: false,
    run_id: null,
    org_id: null,
    uberErrorResponse: null,
    httpStatusCode: 0,
    errorMessage: null,
    warningMessage: null,
    infoMessage: null
  });

  const xCancelSourceForGrid = useRef(null);

  const [open, setOpen] = useState(false);
  const[validationMsg, setValidationMsg] = useState("");
  const[showAPILoader, setShowAPILoader] = useState(false);
  const[showAPILoaderMsg, setShowAPILoaderMsg] = useState("Processing...");


  const [tripDetails, setTripDetails] = useState({
    pickup: {
      latitude: 0,
      longitude: 0,
    },
    dropoff: {
      latitude: 0,
      longitude: 0,
    },
    email: "",
    phonenumber: "",
    vfirstname: "",
    vlastname: "",
    httpResponse: "",
    validationMessage: "",
    dTripEstDst: 0,
    vDstUnt:"",
    dTripEstDur: 0,
    iRefID: -1,
    dMinCancFee: 0,
    vPickRemarks: "",
    TNCExternalDispatch: {
      iTNCId:  -1,
      vTNCName:  "",
      iRefID:  0,
      dTripEstDst:  0,
      vDstUnt:  "",
      iTripEstDur: 0,
      vPhoneNumber:  "",
      vResPayload: "",
      vReqPayload: "",
      dMinCancFee:  0,
      vExternalRequestId: "",
      vExternalProductId:  "",
      vExternalFareId:  "",
      vExternalReqStatus:  "",
      dtCreated: "-",
      dtModified:  "-",
      dFare:  0,
      Success: 0
    },
    dtPickupDate: "",
    OriginalAffiliate: -1
  });

  const updateTripDetails = (data) => {
    setTripDetails({
      pickup: {
        latitude: data.pickup.latitude,
        longitude: data.pickup.longitude,
      },
      dropoff: {
        latitude: data.dropoff.latitude,
        longitude: data.dropoff.longitude,
      },
      email: data.email,
      phonenumber: data.phonenumber,
      vfirstname: data.vfirstname,
      vlastname: data.vlastname,
      httpResponse: data.httpResponse,
      validationMessage: data.validationMessage,
      vPickRemarks: data.vPickRemarks,
      TNCExternalDispatch: {
        iTNCId: data?.tncExternalDispatch?.iTNCId ?? -1,
        vTNCName:data?.tncExternalDispatch?.vTNCName ?? "",
        iRefID:data?.tncExternalDispatch?.iRefID ?? 0,
        dTripEstDst:data?.tncExternalDispatch?.dTripEstDst ?? 0,
        vDstUnt:data?.tncExternalDispatch?.vDstUnt ?? "",
        iTripEstDur:data?.tncExternalDispatch?.iTripEstDur ?? 0,
        vPhoneNumber:data?.tncExternalDispatch?.vPhoneNumber ?? "",
        vResPayload:data?.tncExternalDispatch?.vResPayload ?? "",
        vReqPayload:data?.tncExternalDispatch?.vReqPayload ?? "",
        dMinCancFee:data?.tncExternalDispatch?.dMinCancFee ?? 0,
        vExternalRequestId:data?.tncExternalDispatch?.vExternalRequestId ?? "",
        vExternalProductId:data?.tncExternalDispatch?.vExternalProductId ?? "",
        vExternalFareId:data?.tncExternalDispatch?.vExternalFareId ?? "",
        vExternalReqStatus:data?.tncExternalDispatch?.vExternalReqStatus ?? "",
        dtCreated:data?.tncExternalDispatch?.dtCreated ?? "",
        dtModified:data?.tncExternalDispatch?.dtModified ?? "",
        dFare:data?.tncExternalDispatch?.dFare ?? 0,
        Success:data?.tncExternalDispatch?.success ?? 0
      },
      dtPickupDate: data?.dtPickupDate,
      OriginalAffiliate: data?.OriginalAffiliate
    });
  };

  useEffect(() => {
    setAffiliateID(props.selectedAffiliate);
  }, [props.selectedAffiliate]);

  useEffect(() => {
    const _fetchTripEstimates = async () => {
      setSelectedRefID(parseInt(props.selectedRow[0].iRefID));
      setOriginalAffiliateID(parseInt(props.selectedRow[0].iSRATSPID));
      setTripPickupDatetime(parseInt(props.selectedRow[0].PickupDateTime));
      if(props.selectedRow[0].CallbackInfo){
        setCallBackInfo(props.selectedRow[0].CallbackInfo);
      }
      else if(props.selectedRow[0].Phone){
        setCallBackInfo(props.selectedRow[0].Phone);
      }
      await GetTripDetails(props.selectedRow[0].iRefID);
    }
    _fetchTripEstimates();
    EnabledDisableUberSandbox();
  }, []);


  function EnabledDisableUberSandbox(){
    try {
      if(GlobalASCSData.find(dict => dict.SubTitle === "EnableUberSandbox")?.value === '0'){
        setEnabledSandBox(false);
      }
      else if(GlobalASCSData.find(dict => dict.SubTitle === "EnableUberSandbox")?.value === '1'){
        setEnabledSandBox(true);
      }
      else{
        setEnabledSandBox(false);
      }
    } catch (error) {
      setEnabledSandBox(false);
    }
  }

  const DriverNoteMsg = (msg) => {
    try {
      if(msg){
        setDriverNote(msg);
      }
    } catch (error) {
      
    }
  }

  const handleAction = async(action) => {
    console.log(`API call: ${action}`);
    if (action === "Trip Status") setActiveTripType("Scheduled");
    if (action === "Get Rider Info") 
    {
      await handleGuestDetails();
      setActiveTripType("On Demand");
    }
    else if (action === "Cancel Trip" || action === "Un-Assign"){
      try {
        //setActiveTripType("Flexible");
        await handleCancelTripByRequestId();
      } catch (error) {
        
      }
    }
    else if(action === "Msg Driver"){
      toggleDriverMsgSection();
      //await handleMsgToDriver();
    }
    else if(action === "Request Call"){
      toggleEstablishCallSection();
    }
    if (action === "Retrieve Receipt"){}// setActiveTripType("Reserve");
  };


  const fetchTripEstimates = async (obj) => {
    try {
      setShowAPILoader(true);
      setShowAPILoaderMsg("Please wait, Fetching Trip Estimates...");
      setLoading(true);
      setError("");
      let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/TripEstimate", "post", { "Content-Type": "application/json" }, JSON.stringify(obj), xCancelSourceForGrid.current);
      if (response?.data?.errorMessage != "" && response?.data?.errorMessage != null) {
        setDialogHeader("Trip Estimates");
        setValidationMsg(response.data.errorMessage);
        setOpen(true);
        return;
      }

      const result = await response.data;
      setData(result);
    } catch (err) {
      setError(err.message || "Failed to fetch trip estimates");
      setShowAPILoader(false);
      setDialogHeader("Validation");
    } finally {
      setLoading(false);
      setShowAPILoader(false);
      setShowAPILoaderMsg("");
    }
  };

  const CreateTrip = async() => {
      if(!selectedProductId){
        alert("Please select a valid product to continue...");
      }
      setShowAPILoader(true);
      setShowAPILoaderMsg("Please wait, Sending Trip...");

      if(tripDetails && tripDetails != null){
        try {
          if(selectedProductId && props.selectedRow){
            setLoading(true);
            let selectedProductDetails = undefined;
            if(data?.product_estimates != undefined && data?.product_estimates != null){
              selectedProductDetails = data?.product_estimates.find(p => p.product.product_id === selectedProductId);
            }
            let dTripEstDst = 0;
            let dFare = 0;
            let vDstUnt = "";
            let iTripEstDur = 0;
            let iRefID = -1;
            let dMinCancFee = 0;
            let vExternalFareId = "";
            if(selectedProductDetails != undefined && selectedProductDetails != null){
              try {
                vExternalFareId = selectedProductDetails.estimate_info.fare.fare_id;
                dTripEstDst = selectedProductDetails.estimate_info.trip.distance_estimate;
                dFare = selectedProductDetails.estimate_info.fare.value;
                vDstUnt = selectedProductDetails.estimate_info.trip.distance_unit;
                iTripEstDur = selectedProductDetails.estimate_info.trip.duration_estimate;// Est Traval time in seconds
                dMinCancFee = selectedProductDetails.product.cancellation.min_cancellation_fee;  
              } catch (error) {}
            }

            let requestObj = {
              "ref_id": selectedRefID,
              "product_id": selectedProductId,
              "call_enabled" : callRider,
              "note_for_driver": driverNote,
              "guest": {
                "email": tripDetails.email,
                "first_name": tripDetails.vfirstname,
                "last_name": tripDetails.vlastname,
                "phone_number": tripDetails.phonenumber
              },
              "pickup":{
                "latitude":tripDetails.pickup.latitude,
                "longitude":tripDetails.pickup.longitude,
              },
              "dropoff":{
                "latitude":tripDetails.dropoff.latitude,
                "longitude":tripDetails.dropoff.longitude,
              },
              "external_fare_id": vExternalFareId,
              "trip_est_dst": dTripEstDst,
              "fare": dFare,
              "dst_unt": vDstUnt,
              "trip_est_dur": iTripEstDur,
              "min_canc_fee": dMinCancFee,
              "tnc_id": affiliateID,
              "dtPickupDate": tripDetails.dtPickupDate,
              "OriginalAffiliate": tripDetails.OriginalAffiliate
            }
            
            setError("");
            let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/CreateHealthTrip", "post", {}, requestObj, xCancelSourceForGrid.current);
            if (response?.data?.errorMessage != "" && response?.data?.errorMessage != null && response?.data?.httpStatusCode != 200) {
              setValidationMsg(response.data.errorMessage);
              setShowTripCreatedDialogContent(false);
              setOpen(true);
            }
            else{
              const result = await response.data;
              setCreatedTripResponse(result);
              setTimeout(() => {
                setDialogHeader("Uber Response");
                setShowTripCreatedDialogContent(true);
                setOpen(true);
              }, 500);
              const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
              await sleep(1000);
              await GetTripDetails(props.selectedRow[0].iRefID, false);
              
            }
            setLoading(false);
            setShowAPILoader(false);
            setShowAPILoaderMsg("");
          }
          
        } catch (error) {
          setCreatedTripResponse(null);
          setLoading(false);
          setShowAPILoader(false);
          setShowAPILoaderMsg("");
        }
        finally {
          setLoading(false);
        }
      }
  }

  
  async function GetTripDetails(refID, fetchEstimate = true){
    try {
        setShowAPILoader(true);
        setShowAPILoaderMsg("Please wait, Getting Trip Details...");
        setLoading(true);
        setError("");
        let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","GetTipDetails", "post",  { "Content-Type": "application/json" }, parseInt(refID) , xCancelSourceForGrid.current);
        if (response.error != "") {
          setShowAPILoaderMsg("");
          setValidationMsg(response.error);
          setShowTripCreatedDialogContent(false);
          setOpen(true);
          return;
          //throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const result = await response;
        updateTripDetails(result.data);
        DriverNoteMsg(result.data.vPickRemarks);
        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
        await sleep(500);
        let obj = {
          "pickup": {
            "latitude": result.data.pickup.latitude,
            "longitude": result.data.pickup.longitude,
          },
          "dropoff": {
            "latitude": result.data.dropoff.latitude,
            "longitude": result.data.dropoff.longitude,
          },
          "iRefID": result.data?.tncExternalDispatch?.iRefID ?? 0,
          "email": result.data.email,
          "phonenumber": result.data.phonenumber,
          "vfirstname": result.data.vfirstname,
          "vlastname": result.data.vlastname,
          "vPickRemarks": result.data.vPickRemarks,
          "TNCExternalDispatch": {
            "iTNCId": result.data?.tncExternalDispatch?.iTNCId ?? -1,
            "vTNCName": result.data?.tncExternalDispatch?.vTNCName ?? "",
            "iRefID": result.data?.tncExternalDispatch?.iRefID ?? 0,
            "dTripEstDst": result.data?.tncExternalDispatch?.dTripEstDst ?? 0,
            "vDstUnt": result.data?.tncExternalDispatch?.vDstUnt ?? "",
            "iTripEstDur": result.data?.tncExternalDispatch?.iTripEstDur ?? 0,
            "vPhoneNumber": result.data?.tncExternalDispatch?.vPhoneNumber ?? "",
            "vResPayload": result.data?.tncExternalDispatch?.vResPayload ?? "",
            "vReqPayload": result.data?.tncExternalDispatch?.vReqPayload ?? "",
            "dMinCancFee": result.data?.tncExternalDispatch?.dMinCancFee ?? 0,
            "vExternalRequestId": result.data?.tncExternalDispatch?.vExternalRequestId ?? "",
            "vExternalProductId": result.data?.tncExternalDispatch?.vExternalProductId ?? "",
            "vExternalFareId": result.data?.tncExternalDispatch?.vExternalFareId ?? "",
            "vExternalReqStatus": result.data?.tncExternalDispatch?.vExternalReqStatus ?? "",
            "dtCreated": result.data?.tncExternalDispatch?.dtCreated ?? null,
            "dtModified": result.data?.tncExternalDispatch?.dtModified ?? null,
            "dFare": result.data?.tncExternalDispatch?.dFare ?? 0,
            "Success": result.data?.tncExternalDispatch?.success ?? 0
          },
          "dtPickupDate": result.data?.dtPickupDate,
          "OriginalAffiliate": result.data?.OriginalAffiliate
        }
        ShowTripDetailsSection(obj);
          if(result.data?.tncExternalDispatch?.vExternalRequestId == undefined
             || result.data?.tncExternalDispatch?.vExternalRequestId == "" 
             || result.data?.tncExternalDispatch?.vExternalRequestId == null)
             {
              setFetcTripEstimates(true);
               await fetchTripEstimates(obj);
             }
             else{
              setFetcTripEstimates(false);
             }
      } catch (err) {
        setError(err.message || "Failed to get trip details");
        setShowAPILoader(false);
        setShowAPILoaderMsg("");

        setValidationMsg(err.message);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      } finally {
        setLoading(false);
        setShowAPILoader(false);
        setShowAPILoaderMsg("");
      }
  } 

  function ShowTripDetailsSection(obj){
    try {
      if(obj?.TNCExternalDispatch?.Success === 1)
      //   && obj?.TNCExternalDispatch?.vExternalReqStatus !== "driver_canceled" && obj?.TNCExternalDispatch?.vExternalReqStatus !== "rider_canceled")
      {
        setIsTripAlreadyCreated(true);
        setShowTripConfigurations(false);
      }
      else{
        setIsTripAlreadyCreated(false);
        setShowTripConfigurations(true);
      }

    } catch (error) {
      
    }
  }


  async function handleCreateRun(){
    try {
      setLoading(true);//for disabling controls
      if(sandboxEnabled === false){
        setValidationMsg("Enable Sandbox to create a run.");
        setShowTripCreatedDialogContent(false);
        setOpen(true);
        setLoading(false);
        return; 
      }
      setShowAPILoader(true);
      setShowAPILoaderMsg("Please wait, Creating a Sandbox Run...");
      setError("");
      let requestObj = {};// It should be empty because at backend we have default parameters. (run is creaed for san fran..)
      let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/CreateSandboxRun", "post", {}, 
          requestObj, xCancelSourceForGrid.current);
      if (response?.data?.errorMessage != "" && response?.data?.errorMessage != null && response?.data?.httpStatusCode != 200) {
        setValidationMsg(response.data.errorMessage);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      }
      else{
        const result = await response.data;
        setRunId(result.run_id);
        setRunResponse(result);
      }

    } catch (error) {
      
    }
    finally{
      ResetLoader();
    }
  }

  async function handleGetCreatedRun(){
    try {
      setLoading(true);//for disabling controls
      if(sandboxEnabled === false){
        setValidationMsg("Enable Sandbox to get the already created run details.");
        setShowTripCreatedDialogContent(false);
        setOpen(true);
        setLoading(false);
        return; 
      }
      setShowAPILoader(true);
      setShowAPILoaderMsg("Please wait, Getting already existed Sandbox Run...");
      setError("");
      
      let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/GetSandboxRun", "post", {}, 
          runId,  xCancelSourceForGrid.current);
      if (response?.data?.errorMessage != "" && response?.data?.errorMessage != null && response?.data?.httpStatusCode != 200) {
        setValidationMsg(response.data.errorMessage);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      }
      else{
        const result = await response.data;
        setRunId(result.run_id);
        setRunResponse(result);
      }

    } catch (error) {
      
    }
    finally{
      ResetLoader();
    }
  }
  
  
  function ResetLoader(){
    try {
      setShowAPILoader(false);
      setShowAPILoaderMsg("");
      setError("");
      setLoading(false);
    } catch (error) {
      
    }
  }

  const handleDriverOperation = async (action) => {
    try {
      setShowAPILoader(true);
      setShowAPILoaderMsg("Please wait, Trying to update uber driver state as " + action);
      setError("");
      setLoading(true);

      if(sandboxEnabled === false){
        setValidationMsg("Enable Sandbox or check run creation.");
        setShowTripCreatedDialogContent(false);
        setOpen(true);
        setLoading(false);
        return; 
      }
      let obj = {
        "run_id": "",
        "driver_id": "",
        "driver_state": action
      }
      if(action === "Unable_to_Accept_Ride" || action === "Show Trip Logs"){
        ResetLoader();
        return;
      }
      let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/UpdateSandboxDriverState", "post", {}, obj,  xCancelSourceForGrid.current);
      if (response?.data?.errorMessage != "" && response?.data?.errorMessage != null && response?.data?.httpStatusCode != 200) {
        setValidationMsg(response.data.errorMessage);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      }
      else if(response.error != undefined && response.error != null && response.error != ""){
        setValidationMsg(response.error);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      }
      else{
        const result = await response.data;
        setValidationMsg(result.infoMessage);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      }
    }
    catch(e){
      ResetLoader();
    }
    finally{
      ResetLoader();
    }
  }

  async function handleTripEventInfo(){
    try {
      if(!tripDetails.TNCExternalDispatch?.vExternalRequestId){
        return;
      }
      let vExternalRequestId = tripDetails.TNCExternalDispatch?.vExternalRequestId;
      setShowAPILoader(true);
      setShowAPILoaderMsg("Please wait, Getting Trip events Detailed Info...");
      setLoading(true);
      setError("");
      let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","GetTripEventInfo", "post",  { "Content-Type": "application/json" }, vExternalRequestId , xCancelSourceForGrid.current);
      if (response.error != "") {
        setShowAPILoaderMsg("");
        setValidationMsg(response.error);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
        return;
      }
        const result = await response;
        setValidationMsg(<UberTripEventDetailedInfo tncExternalDispatch={result.data?.tncExternalDispatchList}></UberTripEventDetailedInfo>);
        setOpen(true);
      } catch (err) {
        setError(err.message || "Failed to get trip details");
        setShowAPILoader(false);
        setShowAPILoaderMsg("");

        setValidationMsg(err.message);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      } finally {
        setLoading(false);
        setShowAPILoader(false);
        setShowAPILoaderMsg("");
      }
  } 
  
  async function handleTripDetailedInfo(){
    try {
      if(!tripDetails.TNCExternalDispatch?.vExternalRequestId){
        return;
      }
      let vExternalRequestId = tripDetails.TNCExternalDispatch?.vExternalRequestId;
      let requestObj = {
        "request_id": vExternalRequestId,
      }
      setShowAPILoader(true);
      setShowAPILoaderMsg("Please wait, Getting Trip Detailed Info...");
      setLoading(true);
      setError("");
      let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/GetHealthTripDetails", "post",  { "Content-Type": "application/json" }, requestObj , xCancelSourceForGrid.current);
      if (response.error != "") {
        setShowAPILoaderMsg("");
        setValidationMsg(response.error);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
        return;
      }
        const result = await response;
        setDialogHeader("Uber Trip Details");
        DriverNoteMsg(result.data?.note_for_driver);
        setCallRider(result.data?.call_enabled);
        setValidationMsg(<UberTripDetailedInfo data={result.data}></UberTripDetailedInfo>);
        setOpen(true);
      } catch (err) {
        setError(err.message || "Failed to get trip details");
        setShowAPILoader(false);
        setShowAPILoaderMsg("");

        setValidationMsg(err.message);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      } finally {
        setLoading(false);
        setShowAPILoader(false);
        setShowAPILoaderMsg("");
      }
} 

async function handleCancelTripByRequestId(){
  try {
    if(!tripDetails.TNCExternalDispatch?.vExternalRequestId){
      return;
    }
    let vExternalRequestId = tripDetails.TNCExternalDispatch?.vExternalRequestId;
    let requestObj = {
      "request_id": vExternalRequestId,
    }
    setShowAPILoader(true);
    setShowAPILoaderMsg("Please wait, Processing your request...");
    setLoading(true);
    setError("");
    let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/CancelHealthTrip", "post",  { "Content-Type": "application/json" }, requestObj , xCancelSourceForGrid.current);
    if (response.error != "") {
      setShowAPILoaderMsg("");
      setValidationMsg(response.error);
      setShowTripCreatedDialogContent(false);
      setOpen(true);
      return;
    }
      const result = await response;
      setDialogHeader("Uber Trip Cancellation");
      setValidationMsg(result.data?.infoMessage);
      setOpen(true);
    } catch (err) {
      setError(err.message || "Failed to get trip details");
      setShowAPILoader(false);
      setShowAPILoaderMsg("");

      setValidationMsg(err.message);
      setShowTripCreatedDialogContent(false);
      setOpen(true);
    } finally {
      setLoading(false);
      setShowAPILoader(false);
      setShowAPILoaderMsg("");
    }
  }
  const getButtonColor = (label) => {
    switch (label) {
      case "Get Rider Info":
        return "info";
      case "Trip Status":
        return "primary";
      case "Driver Dtl.":
        return "info";
      case "Msg Driver":
        return "info";
      case "Cancel Trip":
        return "error";
      case "Un-Assign":
        return "info";
      case "Retrieve Receipt":
        return "info";
      default:
        return "info";
    }
  };

  async function handleGuestDetails(){
    try {
      if(!tripDetails.TNCExternalDispatch?.vExternalRequestId){
        return;
      }
      let vExternalRequestId = tripDetails.TNCExternalDispatch?.vExternalRequestId;
      let requestObj = {
        "request_id": vExternalRequestId,
        "guest": {
          "guest_id": createdTripResponse?.guest.guest_id,
          "first_name": tripDetails?.vfirstname,
          "last_name": tripDetails?.vlastname,
          "phone_number": tripDetails?.phonenumber
        }
      }
      setShowAPILoader(true);
      setShowAPILoaderMsg("Please wait, Processing your request...");
      setLoading(true);
      setError("");
      let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/GuestDetails", "post",  { "Content-Type": "application/json" }, requestObj , xCancelSourceForGrid.current);
      if (response.error != "") {
        setShowAPILoaderMsg("");
        setValidationMsg(response.error);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
        return;
      }
        const result = await response;
        setDialogHeader("Rider Subscription Info");
        setValidationMsg(<UberGuestRider data={result.data}></UberGuestRider>)
        setOpen(true);
      } catch (err) {
        setError(err.message || "Failed to get Guest Rider Subscription");
        setShowAPILoader(false);
        setShowAPILoaderMsg("");
  
        setValidationMsg(err.message);
        setShowTripCreatedDialogContent(false);
        setOpen(true);
      } finally {
        setLoading(false);
        setShowAPILoader(false);
        setShowAPILoaderMsg("");
      }
    }

async function toggleDriverMsgSection(){
  try {
    setShowDriverMessageSection(prev => !prev);
  } catch (error) {
    
  }
}

async function toggleEstablishCallSection(){
  try {
    setShowEstablishCallSection(prev => !prev);
  } catch (error) {
    
  }
}

async function handleMsgToDriver(){
  try {
    if(!tripDetails.TNCExternalDispatch?.vExternalRequestId){
      return;
    }    
    let vExternalRequestId = tripDetails.TNCExternalDispatch?.vExternalRequestId;
    let requestObj = {
      "request_id": vExternalRequestId,
      "message": driverMessage,
      "guest": {
        "guest_id": createdTripResponse?.guest.guest_id,
        "first_name": tripDetails?.vfirstname,
        "last_name": tripDetails?.vlastname,
        "phone_number": tripDetails?.phonenumber
      }
    }
    setShowAPILoader(true);
    setShowAPILoaderMsg("Please wait, Trying to send message...");
    setLoading(true);
    setError("");
    let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/SendMsgToUberDriver", "post",  { "Content-Type": "application/json" }, requestObj , xCancelSourceForGrid.current);
    if (response.error != "") {
      setShowAPILoaderMsg("");
      setValidationMsg(response.error);
      setShowTripCreatedDialogContent(false);
      setOpen(true);
      return;
    }
      const result = await response;
      setDialogHeader("Message");
      if(result.data?.errorMessage){
        setValidationMsg(result.data.errorMessage);
      }
      else{
        setValidationMsg(result.data.infoMessage);
      }
      
      setOpen(true);
    } catch (err) {
      setError(err.message || "Failed to send msg to driver.");
      setShowAPILoader(false);
      setShowAPILoaderMsg("");

      setValidationMsg(err.message);
      setShowTripCreatedDialogContent(false);
      setOpen(true);
    } finally {
      setLoading(false);
      setShowAPILoader(false);
      setShowAPILoaderMsg("");
    }
  }

  
async function handleEstablishCallWithDriver(){
  try {
    if(!tripDetails.TNCExternalDispatch?.vExternalRequestId){
      return;
    }

    let vExternalRequestId = tripDetails.TNCExternalDispatch?.vExternalRequestId;
    let requestObj = {
      "request_id": vExternalRequestId,
      "guest": {
        "phone_number":phoneNumber
      }
    }
    setShowAPILoader(true);
    setShowAPILoaderMsg("Please wait, Sending call request to Uber driver...");
    setLoading(true);
    setError("");
    let response = await APICom.fetchData("EXTERNAL_DISPATCH_API","api/Uber/InitiateDriverRecipientPhoneCall", "post",  { "Content-Type": "application/json" }, requestObj , xCancelSourceForGrid.current);
    if (response.error != "") {
      setShowAPILoaderMsg("");
      setValidationMsg(response.error);
      setShowTripCreatedDialogContent(false);
      setOpen(true);
      return;
    }
      const result = await response;
      setDialogHeader("Establishing Call Response");
      if(result.data?.errorMessage){
        setValidationMsg(result.data.errorMessage);
      }
      else{
        setValidationMsg(result.data.infoMessage);
      }
      setOpen(true);
    } catch (err) {
      setError(err.message || "Failed to establish call with uber driver.");
      setShowAPILoader(false);
      setShowAPILoaderMsg("");

      setValidationMsg(err.message);
      setShowTripCreatedDialogContent(false);
      setOpen(true);
    } finally {
      setLoading(false);
      setShowAPILoader(false);
      setShowAPILoaderMsg("");
    }
  }
  return (
    <>
  {showAPILoader ? 
    <div style={{marginRight: "6%"}}>
      <div className="loader" style={{color: "black", borderColor: "black"}}></div>
      <p style={{background:"#ffe6c8", color: "black", textAlign: "center", padding: "5px"}}>{showAPILoaderMsg}</p>
    </div> : ""}
    
    <Box sx={{ border: 0, overflow: "auto", height: "100%" }}>
    
      {/** Section for SandBox Environment, This should be visible based on ASCS settings */}
      {enabledSandBox ?
        <Box sx={{ border: "1px solid lightgray", borderRadius: 2, overflow: "hidden", mr: 6 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 1.5,
              bgcolor: "grey.200",
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              Uber Sandbox Controls
            </Typography>

            <IconButton onClick={() => setShowPanel((prev) => !prev)} size="small">
              {showPanel ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>

          <Collapse in={showPanel} timeout="auto" unmountOnExit>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1.5,
                bgcolor: sandboxEnabled ? "success.light" : "grey.100",
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                Sandbox Mode
              </Typography>

              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">
                  {sandboxEnabled ? "Enabled" : "Disabled"}
                </Typography>
                <Switch
                  color="success"
                  checked={sandboxEnabled}
                  onChange={() => setSandboxEnabled((prev) => !prev)}
                />
              </Box>
            </Box>

            <Collapse in={sandboxEnabled} timeout="auto" unmountOnExit>
              <Box sx={{ p: 2 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} display="flex" alignItems="center" gap={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={loading}
                      onClick={handleCreateRun}
                    >
                      {loading ? "Creating Run..." : "New Run"}
                    </Button>
                      {runId && (
                        <CheckCircle sx={{ color: "green", fontSize: 20 }} />
                      )}
                    <TextField
                      label="Run ID"
                      size="small"
                      value={runId}
                      disabled={true}
                      sx={{ width: runId ? `${runId.length + 2}ch` : "6ch",}}
                      onChange={(e) => setRunId(e.target.value)}  
                    >
                    </TextField>
                    
                    
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Drivers List:
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {runResponse?.driver_ids ? runResponse.driver_ids : "N/A"}
                      </Typography>
                    </Box>
                    {/* {runId && ( */}
                      <Grid item>
                        <Button
                          variant="outlined"
                          color="primary"
                          disabled={loading}
                          onClick={handleGetCreatedRun}
                        > Get Run
                        </Button>
                      </Grid>
                    {/* )} */}
                  </Grid>
                </Grid>

                <Box>
                  <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                    Driver Operations:
                  </Typography>
                  <Grid container spacing={1}>
                    {[
                      "ACCEPT",
                      "ARRIVED",
                      "BEGIN_TRIP",
                      "DROPOFF",
                      "CANCEL",
                      "GO_ONLINE",
                      "GO_OFFLINE"
                      // "Unable_to_Accept_Ride",
                      //"Show Trip Logs"
                    ].map((action) => (
                      <Grid item key={action}>
                        <Button
                          variant="contained"
                          size="small"
                          disabled={loading || !runId || !isTripAlreadyCreated}
                          onClick={() => handleDriverOperation(action)}
                        >
                          {action.replaceAll("_", " ")}
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </Collapse>
          </Collapse>
        </Box>
      : ""}
      {/** Section for Real Features, Environment, This should be visible based on ASCS settings */}
      <Box sx={{ border: "0px solid lightgray", borderRadius: 2, p: 0, mt: 1, mr: 6 }}>
        <Grid container spacing={1} sx={{ mb: 0,  justifyContent: "flex-end" }}>
          {[
            // "Get Rider Info",
            //"Trip Status",
            //"Driver Dtl.",
            "Msg Driver",
            // "Retrieve Receipt",
            "Request Call",
            "Un-Assign"
          ].filter(label => {
              if (!enabledSandBox) {
                return label !== "Retrieve Receipt" && label !== "Cancel Trip";
              }
              return true;
            })
            .map((label) => {
              let isDisabled = false;

              if (isTripAlreadyCreated === false) {
                isDisabled = true;
              }

              let icon = null;
              switch (label) {
                case "Msg Driver":
                  icon = <MessageIcon fontSize="small" />;
                  break;
                case "Request Call":
                  icon = <CallIcon fontSize="small" />;
                  break;
                case "Un-Assign":
                  icon = <BlockIcon fontSize="small" />;
                  break;
                default:
                  icon = null;
              }
              return (
                <Grid item key={label}>
                  <Button
                    variant="contained"
                    size="small"
                    color={getButtonColor(label)}
                    disabled={loading || isDisabled}
                    onClick={() => handleAction(label)}
                    startIcon={icon}
                  >
                    {label}
                  </Button>
                </Grid>
              );
            })}
        </Grid>

        {/* ===================================== DRIVER RECIPIENT PHONE CALL ====================== */}
         {showEstablishCallSection && (
           <Grid item xs={12} sm={8} container
           justifyContent="flex-end"
           alignItems="center"
           spacing={1}
           style={{marginTop: "15px", marginRight: "0%"}}
           >
            <RadioGroup
              row
              value={selectedCall}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedCall(value);
                if (value === "rider"){
                  if(callBackInfo){
                    setPhoneNumber(callBackInfo);
                  }
                  else{
                    setPhoneNumber("");
                  }
                }
                if (value === "dispatcher") {
                  setPhoneNumber("");
                }
              }}
            >
              <FormControlLabel value="rider" control={<Radio />} label="Rider Call" />
              <FormControlLabel value="dispatcher" control={<Radio />} label="Dispatcher Call" />
            </RadioGroup>
            <TextField
              fullWidth
              size="small"
              padding="5px"
              placeholder="Phone#"
              sx={{ ml: 2,  width: 250}} 
              value={phoneNumber}
              onChange={(e) => {
                let digits = e.target.value.replace(/\D/g, "");
                // Limit to 10 digits
                if (digits.length > 10) digits = digits.slice(0, 10);
            
                // Format as (123) 456-7890
                let formatted = digits;
                if (digits.length > 6) {
                  formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
                } else if (digits.length > 3) {
                  formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
                } else if (digits.length > 0) {
                  formatted = `(${digits}`;
                }
            
                setPhoneNumber(formatted);
              }}
              disabled={selectedCall !== "dispatcher" || loading} 
              InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                   {phoneNumber && (
                    <Button
                      size="small"
                      variant="text"
                      color="error"
                      onClick={() => setPhoneNumber("")}
                      sx={{ minWidth: 0, px: 0.5, mr: 2 }}
                    >
                      X
                    </Button>
                  )}
                  <Button
                    size="small"
                    variant="contained"
                    color="success"
                    disabled={loading || phoneNumber.trim() === "" || !phoneNumber.trim().length >= 10 } 
                    onClick={handleEstablishCallWithDriver}
                  >
                    {loading ? "Sending..." : "Call"}
                  </Button>
                </InputAdornment>
              ),
            }}
          />
          </Grid>
         )}
        {showDriverMessageSection && (
          <Grid item xs={12} sx={{ mt:1, mb: 1 }} style={{marginRight: "0%"}}>
          <TextField
            fullWidth
            size="small"
            padding="5px"
            style={{fontStyle: "italic"}}
            placeholder="Write a message to driver..."
            value={driverMessage}
            onChange={(e) => setDriverMessage(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                   {driverMessage && (
                      <Button
                        size="small"
                        variant="text"
                        color="error"
                        onClick={() => setDriverMessage("")}
                        sx={{ minWidth: 0, px: 0.5, mr: 3 }}
                      >
                        X
                      </Button>
                  )}
                  <Button
                    size="small"
                    variant="contained"
                    color="success"
                    disabled={loading || driverMessage.trim() === ""} 
                    onClick={handleMsgToDriver}
                  >
                    {loading ? "Sending..." : "Send"}
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        )}

        <Grid container alignItems="center">
          <Grid
            item
            xs={9}
            display="flex"
            alignItems="center"
            gap={1}
            flexWrap="wrap"
          >
          </Grid>
        </Grid>
        {isTripAlreadyCreated ? 
            <Grid item xs={3}>
            <Box sx={{ border: "0px solid lightgray", borderRadius: 2, p: 0, mt: 2 }}>
                   <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      background: "#e6e6e6",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      paddingTop: "5px",
                      paddingBottom: "5px"
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      Details
                    </Typography>
                    <div>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleTripDetailedInfo}
                        style={{ marginRight: "8px" }}
                      >
                        Detailed Info.
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleTripEventInfo}
                      >
                        Events.
                      </Button>
                    </div>
                  </div>
              <Divider sx={{ mb: 0.5 }} />
              <Grid container spacing={5} sx={{ mb: 1 }} style={{marginLeft: "5px"}}>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Confirmation#
                  </Typography>
                  <Typography style={{fontStyle: "italic"}}>
                    {tripDetails.TNCExternalDispatch?.iRefID || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Uber Status
                  </Typography>
                  {(() => {
                      const status = tripDetails.TNCExternalDispatch?.vExternalReqStatus?.toLowerCase();
                      const colors = statusColors[status] || { bg: "#E0E0E0", color: "#000" };
                      return (
                        <Typography
                          sx={{
                            fontStyle: "italic",
                            fontWeight: "bold",
                            backgroundColor: colors.bg,
                            color: colors.color,
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 1,
                            display: "inline-block",
                            textTransform: "capitalize",
                          }}
                        >
                          {status || "-"}
                        </Typography>
                      );
                    })()}
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Request ID
                  </Typography>
                  <Typography>
                    {tripDetails.TNCExternalDispatch?.vExternalRequestId &&
                    <CheckCircle sx={{ color: "green", fontSize: 20, marginRight: "5px" }} />}
                    {tripDetails.TNCExternalDispatch?.vExternalRequestId || "-"}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={8} sx={{ mb: 1 }} style={{marginLeft: "5px"}}>
                <Grid item xs={3}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Est. Dst
                  </Typography>
                  <Typography>{tripDetails.TNCExternalDispatch?.dTripEstDst + " " + tripDetails?.TNCExternalDispatch?.vDstUnt || "-"}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Fare
                  </Typography>
                  <Typography>${tripDetails.TNCExternalDispatch?.dFare || "-"}</Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Est. Dur
                  </Typography>
                  <Typography>{ Math.floor(tripDetails.TNCExternalDispatch?.iTripEstDur / 60) + " min." || "-"}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Min Cancel Fee
                  </Typography>
                  <Typography>${
                  tripDetails.TNCExternalDispatch?.dMinCancFee || "-"}
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={3} sx={{ mb: 1 }} style={{marginLeft: "5px"}}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Phone#
                  </Typography>
                  <Typography>{tripDetails.TNCExternalDispatch?.vPhoneNumber || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: "bold" }}>
                    Created At
                  </Typography>
                  <Typography> {moment(tripDetails.TNCExternalDispatch?.dtCreated).format("DD MMM YYYY, hh:mm A") || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                          control={
                            <Checkbox 
                              disabled={true}
                              checked={callRider} 
                              onChange={(e) => setCallRider(e.target.checked)} 
                            />
                          }
                          label={
                            <Typography variant="subtitle2" fontWeight="bold"  sx={{ fontWeight: "bold" }}>
                              Call Rider
                            </Typography>
                          }
                      />
                </Grid>
              </Grid>
                  <Grid item xs={12} lg={12} style={{marginLeft: "5px"}}>
                      <Typography
                          variant="subtitle2"
                          color="textSecondary"
                          sx={{ fontWeight: "bold" }}
                        >
                        Driver Notes
                      </Typography>
                      <TextField
                        sx={{mt: 0.5}}
                        fullWidth
                        size="medium"
                        multiline
                        rows={2}
                        disabled={true}
                        placeholder="Note for the driver..."
                        value={driverNote}
                        onChange={(e) => setDriverNote(e.target.value)}
                      />
                  </Grid>
            </Box>
            </Grid>  : ""
          }
          {showTripConfigurations ?
           <Grid item xs={3}>
             <Box sx={{ border: "0px solid lightgray", borderRadius: 2, p: 1.5, mt: 2, pr: 0, pl: 0 }}>
             <Stack direction="row" alignItems="center" spacing={1} sx={{ width: "100%" }}>
              <RiderComm fontSize="small" />
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ fontSize: "1rem" }}
              >
                Rider Communication
              </Typography>

              {/* Spacer pushes the checkbox to the end */}
              <Box sx={{ flexGrow: 1 }} />

              <FormControlLabel
                labelPlacement="start"
                label={
                  <Stack direction="row" alignItems="center" spacing={1} sx={{pr: 0, mr: 0}}>
                    <Call fontSize="small" />
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ fontSize: "0.8rem" }}>
                      Call Rider
                    </Typography>
                  </Stack>
                }
                sx={{ whiteSpace: "nowrap" }}
                control={
                  <Checkbox
                    size="small"
                    checked={callRider}
                    onChange={(e) => setCallRider(e.target.checked)}
                  />
                }
              />
            </Stack>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <TextField
                  fullWidth
                  style={{fontStyle: "italic", paddingLeft: "5px"}}
                  size="small"
                  placeholder="Note for the driver…"
                  value={driverNote}
                  onChange={(e) => setDriverNote(e.target.value)}
                  sx={{ flex: 1, mt:1, "& .MuiInputBase-input": { padding: "6px" } }}
                />
              </Box>
            </Box>
         </Grid>
          : ""
          }
      </Box>

      <Box sx={{ border: 0, overflow: "auto", height: "100%", p: 1, mr: 6, pr: 0, pl: 0 }}>
        {fetcTripEstimates &&
        <Box display="flex" alignItems="center" gap={1} textAlign="center">
          <Typography variant="subtitle1" sx={{ minWidth: 100, fontWeight:"bold" }}>
            Select Product:
          </Typography>
          <FormControl sx={{ flex: 1 }}>
            <Select
              labelId="product-select-label"
              value={selectedProductId || ""}
              onChange={(e) => setSelectedProductId(e.target.value)}
              renderValue={(selected) => {
                const selectedItem = data?.product_estimates?.find(
                  (x) => x.product?.product_id === selected
                );
                if (!selectedItem) return "Select Product";
                return selectedItem.product?.display_name;
              }}>
              {(data?.etas_unavailable || data?.fares_unavailable) && (
                <Box style={{display: "flex", justifyContent: "flex-end", paddingRight: "10px", fontStyle:"italic"}}>
                    {data?.etas_unavailable && <p>ETA's are not available</p>}
                    {data?.fares_unavailable && <p>Fare's are not available</p>}
                </Box>
              )}
              {data?.product_estimates?.map((item, index) => {
                const { product, estimate_info } = item;
                
                const fareDisplay =
                estimate_info?.fare?.display ||
                estimate_info?.estimate?.display ||
                "N/A";
                const backgroundColors = ["#f9f9f9", "#f4f4f4"];
                const bgColor = backgroundColors[index % 2];
                return (
                  <MenuItem
                    key={product?.product_id}
                    value={product?.product_id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      py: 1.2,
                      borderBottom: "1px solid #eee",
                      backgroundColor: bgColor,
                    }}
                  >
                    <Box
                      component="img"
                      src={product?.image}
                      alt={product?.display_name}
                      sx={{
                        width: 80,
                        height: 80,
                        objectFit: "cover",
                        borderRadius: 1,
                        mr: 2,
                      }}
                    />
                    <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                      
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography variant="subtitle2" fontWeight="bold" noWrap>
                          {product?.display_name}
                        </Typography>
                        <Typography variant="body2" color="text.primary" style={{fontWeight: "bold"}}>
                          {fareDisplay}
                        </Typography>
                      </Box>
                      
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>

                        <Box display="flex" alignItems="center" gap={0.5}>
                          {!estimate_info?.no_cars_available && (
                            <CheckCircle sx={{ color: "#83ab83", fontSize: 20, marginRight: "5px" }} />
                          )}
                          <Typography variant="caption">
                            {estimate_info?.no_cars_available ? "Car N/A" : "Car Available"}
                          </Typography>
                        </Box>
                        
                        <Typography variant="caption">
                          Est. Trip Dst: {estimate_info?.trip?.distance_estimate
                            ? estimate_info.trip.distance_estimate +
                              " " +
                              estimate_info.trip.distance_unit
                            : "N/A"}
                        </Typography>
                      </Box>
                   
                      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}> 
                        <Typography variant="caption">
                          ETA: {estimate_info?.pickup_estimate != undefined
                            ? estimate_info.pickup_estimate + " mins"
                            : "-"}
                        </Typography>
                      
                        <Typography variant="caption">
                          Est. Travel Time: {estimate_info?.trip?.duration_estimate > 0
                            ? Math.ceil(estimate_info.trip.duration_estimate / 60) + " min"
                            : "N/A"}
                        </Typography>
                      </Box>

                      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
                          <Typography variant="caption">
                            Capacity: {product?.capacity || "N/A"}
                          </Typography>
                          <Typography variant="caption">
                            {product?.shared ? " Shared ride" : " Private ride"}
                          </Typography>
                      </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 0.5 }}>
                          <Typography variant="caption" noWrap style={{fontStyle: "italic"}}>
                            {product?.description}
                          </Typography>

                          {item?.fulfillment_indicator && item.fulfillment_indicator !== "UNKNOWN" && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <Typography
                                variant="caption"
                                title="This indicator shows how likely it is that a ride will be available at your selected time and location."
                              >
                                {{
                                  GREEN: "High Availability",
                                  YELLOW: "Medium Availability",
                                  RED: "Low Availability",
                                }[item.fulfillment_indicator] || "Unknown"}
                              </Typography>
                              <span
                                style={{
                                  background: item.fulfillment_indicator === "YELLOW"
                                  ? "#faaa29"
                                  : item.fulfillment_indicator,
                                  width: "20px",
                                  height: "20px",
                                  display: "inline-block",
                                  borderRadius: "4px",
                                }}
                                title="This indicator shows how likely it is that a ride will be available at your selected time and location."
                              />
                            </Box>
                          )}
                        </Box>
                    </Box>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
        }
        {
         isTripAlreadyCreated == false ? 
              <Box
                sx={{
                  mt: 1,
                  // p: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems:"flex-start",
                  alignItems: "center",
                }}>
                <Button
                  variant="contained"
                  color="success"
                  disabled={!selectedProductId || loading}
                  onClick={CreateTrip}
                  startIcon={<PlayArrow fontSize="small" />}
                >
                {loading ? "Sending..." : "Send Trip"}
                </Button>
              </Box>
              :
            ""
        }
        <Dialog open={open} onClose={() => setOpen(false)} style={{zIndex: "10001"}} fullWidth>
          <DialogTitle>{dialogHeader}</DialogTitle>
          <DialogContent>
            {showTripCreatedDialogContent ?
              <Typography sx={{ whiteSpace: "pre-line" }}>
                Rider Name: {createdTripResponse?.guest.first_name} {createdTripResponse?.guest.last_name}{"\n"}
                Phone: {createdTripResponse?.guest?.phone_number}{"\n"}
                Request Status:{" "}
                <span style={{ color: "orange", fontWeight: "bold" }}>
                  {createdTripResponse?.status}
                </span>
              </Typography> : 
              <Typography color="red">
              {validationMsg}
              </Typography>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>OK</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
    </>
  );
};

export default UberExternalDispatch;
